<template>
    <main-layout>
        <!--<p>NUM OTAG : {{ otag }}</p>-->
    </main-layout>
</template>

<script>


import Operateur from "../../../js/models/Operateur";

export default {
    data(){
        return {
            haveOption: false
        }
    },

    async beforeCreate(){

        let options = await Operateur.getOperateurOptions();
        options.includes("spieDeeplink") ? this.haveOption = true : this.haveOption = false;

        if(this.haveOption === true){
            let id_det = this.$route.params.id_det;
            let id_inst = this.$route.params.id_inst;
            let num_ot = this.$route.params.num_ot;
            let router = this.$router;
            //console.log(document.location.href)
            //console.log(id_det, id_inst, num_ot);

            this.$router.push({ name: 'new-fibsdd', query: { 'detenteur' : id_det, 'installation' : id_inst, 'num_ot' : num_ot } });
        } else {
            swal('Indisponible', 'Cette fonctionnalité n\'a pas été activé sur votre compte opérateur', 'error').then(
                () => {
                    this.$router.push({ name: 'home' });
                }
            )
        }

    }
}
</script>




// WEBPACK FOOTER //
// Spie.vue?65c1e537